// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilterBlock_block__y1mXR label {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Table/FilterBlock.module.scss"],"names":[],"mappings":"AACE;EAAO,SAAA;AACT","sourcesContent":[".block label {\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `FilterBlock_block__y1mXR`
};
export default ___CSS_LOADER_EXPORT___;
